import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "payment-container"
};
const _hoisted_2 = {
  class: "payment-header"
};
const _hoisted_3 = {
  class: "user-boxes"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "change-buttons"
};
const _hoisted_6 = {
  class: "payment-methods"
};
const _hoisted_7 = {
  class: "payment-method"
};
const _hoisted_8 = {
  class: "payment-method"
};
const _hoisted_9 = {
  class: "balance-payment"
};
const _hoisted_10 = {
  class: "button-group"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
  class: "modal-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "可创建用户数：", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.userCounts, (userCount, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["user-box", {
        'selected': $data.selectedUserCountIndex === index
      }]),
      key: index,
      onClick: $event => $options.selectUserCount(index)
    }, [_createElementVNode("span", null, _toDisplayString(userCount), 1)], 10, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => $options.changeUserCount(-1))
  }, "-"), _createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = $event => $options.changeUserCount(1))
  }, "+")])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = $event => $options.selectPaymentMethod('alipay'))
  }, [_createElementVNode("span", {
    class: _normalizeClass(["circle", {
      'checked': $data.paymentMethod === 'alipay'
    }])
  }, null, 2), _cache[15] || (_cache[15] = _createTextVNode(" 支付宝支付 ", -1))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = $event => $options.selectPaymentMethod('balance'))
  }, [_createElementVNode("span", {
    class: _normalizeClass(["circle", {
      'checked': $data.paymentMethod === 'balance'
    }])
  }, null, 2), _createTextVNode(" 账户余额支付 (¥" + _toDisplayString($data.accountBalance) + ") ", 1)])])]), $data.isNotificationVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "modal-overlay",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.closeNotification && $options.closeNotification(...args))
  }, [_createElementVNode("div", {
    class: "modal-content",
    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("h3", null, _toDisplayString($data.notificationMessage), 1), _createElementVNode("button", {
    onClick: _cache[4] || (_cache[4] = (...args) => $options.closeNotification && $options.closeNotification(...args)),
    style: {
      "font-size": "10px",
      "padding": "8px 16px",
      "width": "auto"
    }
  }, "关闭")])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.rechargeBalance && $options.rechargeBalance(...args))
  }, "充值账户余额"), _createElementVNode("button", {
    onClick: _cache[8] || (_cache[8] = (...args) => $options.confirmPayment && $options.confirmPayment(...args)),
    disabled: $data.totalAmount <= 0 || !$data.paymentMethod
  }, " 确认支付（¥" + _toDisplayString($data.totalAmount) + "） ", 9, _hoisted_11)])]), $data.isModalVisible ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "modal-overlay",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.closeModal && $options.closeModal(...args))
  }, [_createElementVNode("div", {
    class: "modal-content",
    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
  }, [_cache[16] || (_cache[16] = _createElementVNode("h3", null, "请输入充值金额", -1)), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.rechargeAmount = $event),
    type: "number",
    placeholder: "请输入充值金额"
  }, null, 512), [[_vModelText, $data.rechargeAmount]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
    onClick: _cache[10] || (_cache[10] = (...args) => $options.submitRechargeAmount && $options.submitRechargeAmount(...args)),
    style: {
      "margin-left": "30px"
    }
  }, "确认充值"), _createElementVNode("button", {
    onClick: _cache[11] || (_cache[11] = (...args) => $options.closeModal && $options.closeModal(...args)),
    style: {
      "margin-right": "30px"
    }
  }, "取消")])])])) : _createCommentVNode("", true)]);
}